import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { STATUSES } from '__constants__'
import { Text } from '@qonsoll/react-design'
import { useSubfilterActions } from 'hooks'
import { useTranslations } from 'contexts/Translation'

const EmailStatusFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslations()

  const { EMAIL_STATUSES } = STATUSES

  const emailStatuses = Object.values(EMAIL_STATUSES)?.map((emailStatus) => {
    if (emailStatus === EMAIL_STATUSES.BLOCKED)
      return { value: true, name: emailStatus }
    return { value: false, name: emailStatus }
  })

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'isBlocked',
    operand: '==',
    type: 'emailStatus'
  })

  return (
    <details
      open={
        localStorage.getItem(`emailStatus-details-visibility`) === 'opened'
      }>
      <summary onClick={onToggleDetails}>{t('Email status')}</summary>
      {emailStatuses?.map((emailStatus, index) => (
        <Checkbox
          key={`status-${index}`}
          checked={checkIsEnabled(emailStatus)}
          onChange={() => onChange(emailStatus)}>
          <Text wordBreak="break-all">
            {emailStatus?.name || t('Unnamed filter')}
          </Text>
        </Checkbox>
      ))}
    </details>
  )
}

EmailStatusFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default EmailStatusFilter
